var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobDivision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_57542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4666 15.3333C17.6513 15.3333 17.7436 15.3333 17.8184 15.3743C17.8802 15.4081 17.9376 15.4716 17.9651 15.5364C17.9984 15.615 17.9901 15.6986 17.9733 15.8657C17.8863 16.7325 17.588 17.5676 17.1011 18.2963C16.5151 19.1734 15.6821 19.857 14.7076 20.2606C13.733 20.6643 12.6607 20.7699 11.6261 20.5641C10.5915 20.3584 9.64123 19.8504 8.89535 19.1045C8.14947 18.3586 7.64152 17.4083 7.43573 16.3738C7.22995 15.3392 7.33556 14.2668 7.73923 13.2923C8.1429 12.3178 8.82648 11.4848 9.70355 10.8988C10.4323 10.4118 11.2674 10.1136 12.1341 10.0266C12.3013 10.0098 12.3849 10.0014 12.4634 10.0348C12.5282 10.0623 12.5918 10.1197 12.6256 10.1815C12.6666 10.2563 12.6666 10.3486 12.6666 10.5333V14.8C12.6666 14.9866 12.6666 15.08 12.7029 15.1513C12.7349 15.214 12.7859 15.265 12.8486 15.297C12.9199 15.3333 13.0132 15.3333 13.1999 15.3333H17.4666Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 7.86662C15.3333 7.68195 15.3333 7.58961 15.3743 7.51478C15.4081 7.45304 15.4716 7.39558 15.5364 7.36809C15.6149 7.33476 15.6985 7.34314 15.8657 7.35991C17.0847 7.48218 18.2306 8.02148 19.1045 8.89538C19.9784 9.76928 20.5177 10.9152 20.64 12.1342C20.6567 12.3013 20.6651 12.3849 20.6318 12.4635C20.6043 12.5283 20.5468 12.5918 20.4851 12.6256C20.4103 12.6666 20.3179 12.6666 20.1333 12.6666L15.8666 12.6666C15.6799 12.6666 15.5866 12.6666 15.5153 12.6303C15.4525 12.5983 15.4015 12.5473 15.3696 12.4846C15.3333 12.4133 15.3333 12.32 15.3333 12.1333V7.86662Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_57542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDivision);
export default __webpack_public_path__ + "static/media/job-division.7fe9df0f66e6ece99552426dae5e61a2.svg";
export { ForwardRef as ReactComponent };